import React from 'react'
import About from 'components/About'
import './Home.scss'

export const HomeView = () => <div className='home-content'>
    <About />
</div>

export default HomeView
